export default {
  "brand.name": "USFansSheet",
  "brand.tagline": "Spreadsheet Hub",

  "nav.spreadsheet": "Spreadsheet",
  "nav.finds": "Trouvailles",
  "nav.guides": "Guides",
  "nav.reviews": "Avis",
  "nav.shipping": "Livraison",
  "nav.coupons": "Coupons",
  "nav.warehouse": "Entrepôt",
  "nav.safety": "Sécurité",
  "nav.faq": "FAQ",
  "nav.home": "Accueil",
  "nav.buyingGuide": "Guide d'achat",
  "mobile.categories": "Parcourir les catégories",

  "hero.badge": "Ressources mises à jour 2026",
  "hero.title": "USFans Spreadsheet — Cherchez mieux, achetez en confiance",
  "hero.subtitle": "La façon la plus intelligente d'explorer les trouvailles USFans. Découvrez des feuilles organisées, des liens W2C, des guides produits, des conseils QC, des infos de livraison et des ressources d'achat — tout en un seul endroit.",
  "hero.ctaPrimary": "usfans spreadsheet",
  "hero.ctaSecondary": "acheter maintenant",
  "hero.trust": "Ressources à jour · Guides d'achat · Éducation QC · Infos de livraison",

  "stats.resources": "Ressources",
  "stats.categories": "Catégories",
  "stats.guides": "Guides",
  "stats.languages": "Langues",

  "dropdown.label": "Parcourir les catégories",
  "dropdown.placeholder": "Choisissez une catégorie à explorer",

  "categories.title": "Catégories USFans Spreadsheet",
  "categories.subtitle": "Accédez directement à n'importe quelle catégorie de la boutique principale — organisé pour comparer les offres plus vite.",

  "category.shoes": "Chaussures",
  "category.hoodies": "Hoodies / Sweats",
  "category.tshirts": "T-Shirts",
  "category.jackets": "Vestes",
  "category.pants": "Pantalons / Shorts",
  "category.headwear": "Couvre-chefs",
  "category.sets": "Ensembles",
  "category.underwear": "Sous-vêtements / Caleçons",
  "category.jersey": "Maillots",
  "category.accessories": "Accessoires",
  "category.bags": "Sacs",
  "category.belts": "Ceintures",
  "category.perfumes": "Parfums",
  "category.other": "Autres articles",

  "articles.title": "Guides populaires USFans Spreadsheet",
  "articles.subtitle": "Des articles originaux et basés sur la recherche pour comprendre le processus avant de commander.",
  "articles.readMore": "Lire le guide",
  "articles.viewAll": "Voir tous les guides",

  "article.1.title": "Qu'est-ce que l'USFans Spreadsheet ? Guide complet 2026",
  "article.1.excerpt": "Une explication claire de ce qu'est l'USFans Spreadsheet, comment il fonctionne et comment l'utiliser pour rechercher des produits, comparer les offres et comprendre le QC avant de commander.",

  "guides.title": "Guides et ressources USFans",
  "guides.subtitle": "Explorez les avis, la livraison, les coupons, l'entrepôt et la sécurité avant de commander.",
  "guides.learnMore": "Lire le guide",
  "guides.1.title": "Avis USFans",
  "guides.1.desc": "Un regard équilibré sur l'expérience d'achat et ce qu'il faut considérer.",
  "guides.2.title": "Coût de livraison USFans",
  "guides.2.desc": "Comprenez poids, lignes et destination avant d'expédier.",
  "guides.3.title": "Coupon USFans",
  "guides.3.desc": "Trouvez et vérifiez les dernières offres de coupons et réductions.",
  "guides.4.title": "Code promo USFans",
  "guides.4.desc": "Comment fonctionnent les codes et à quoi faire attention.",
  "guides.5.title": "Entrepôt USFans",
  "guides.5.desc": "QC, stockage et regroupement expliqués simplement.",
  "guides.6.title": "USFans est-il légitime ?",
  "guides.6.desc": "Vérifications de sécurité et signaux d'alerte à rechercher d'abord.",
  "article.2.title": "Avis USFans 2026 – Est-ce que ça vaut le coup ?",
  "article.2.excerpt": "Un avis équilibré sur l'expérience d'achat USFans : à quoi s'attendre, les points forts et considérations, et à qui cela convient le mieux.",
  "article.3.title": "Guide des frais de livraison USFans 2026",
  "article.3.excerpt": "Comment les frais de livraison USFans sont calculés selon le poids, la ligne et la destination, et des moyens pratiques de les estimer et les réduire.",
  "article.4.title": "Guide des coupons et codes promo USFans",
  "article.4.excerpt": "Où trouver les coupons et codes promo USFans, comment vérifier qu'ils sont à jour et les erreurs courantes à éviter.",
  "article.5.title": "Guide de l'entrepôt USFans 2026",
  "article.5.excerpt": "Comment l'entrepôt USFans gère le QC, le stockage et le regroupement des colis avant l'expédition internationale.",
  "article.6.title": "USFans est-il légitime en 2026 ?",
  "article.6.excerpt": "Un guide de sécurité équilibré pour évaluer les vendeurs, repérer les signaux d'alerte et faire des recherches avant de commander.",
  "article.7.title": "Guide des liens W2C USFans",
  "article.7.excerpt": "Ce que signifie W2C, comment fonctionnent les liens W2C dans la feuille et comment les utiliser en toute sécurité.",
  "article.8.title": "Guide QC USFans – Lire les photos QC",
  "article.8.excerpt": "Apprenez quoi vérifier sur les photos QC : coutures, étiquettes, couleur et proportions, avant l'expédition de votre article.",
  "article.9.title": "Guide d'achat USFans 2026",
  "article.9.excerpt": "Un guide étape par étape couvrant la recherche, la commande, le QC, le paiement et la livraison dans le bon ordre.",
  "article.10.title": "Comment utiliser l'USFans Spreadsheet",
  "article.10.excerpt": "Un parcours pour débutants à travers les catégories et colonnes de la feuille et comment transformer les trouvailles en commandes.",
  "article.11.title": "Guide des trouvailles USFans Spreadsheet",
  "article.11.excerpt": "Ce que sont les trouvailles, les catégories les plus populaires et comment repérer une bonne affaire avant de vous engager.",

  "faq.title": "Questions fréquentes",
  "faq.subtitle": "Des réponses rapides sur l'USFans Spreadsheet et le processus d'achat.",
  "faq.q1": "Qu'est-ce que l'USFans Spreadsheet ?",
  "faq.a1": "L'USFans Spreadsheet est une ressource de recherche organisée qui aide à découvrir des produits, comparer des offres, vérifier les informations disponibles et comprendre le processus d'achat avant de passer commande.",
  "faq.q2": "USFans est-il légitime ?",
  "faq.a2": "Nous fournissons des informations équilibrées et basées sur la recherche pour vous aider à évaluer vous-même les vendeurs et les offres. Vérifiez toujours l'offre, le vendeur et les conditions de livraison avant d'acheter.",
  "faq.q3": "Comment fonctionne USFans ?",
  "faq.a3": "Il fonctionne généralement via un modèle d'agent d'achat ou de transitaire : vous recherchez des produits, envoyez des liens, vérifiez les photos QC puis organisez la livraison internationale vers votre pays.",
  "faq.q4": "Combien coûte la livraison USFans ?",
  "faq.a4": "Le coût de livraison dépend du poids du colis, des dimensions, de la ligne d'expédition et du pays de destination. Consultez le guide de livraison et les tarifs actuels avant de commander, car les estimations peuvent varier.",
  "faq.q5": "Où trouver des coupons USFans ?",
  "faq.a5": "La disponibilité des coupons et remises change souvent. Vérifiez toujours les dernières offres vérifiées et leurs dates d'expiration avant de les utiliser.",

  "safety.title": "Recherchez d'abord. Commandez ensuite.",
  "safety.body": "Une feuille peut vous aider à rechercher des produits, mais aucune offre ne garantit la qualité, la fiabilité du vendeur, la disponibilité ni le résultat de la livraison. Vérifiez toujours les informations actuelles avant de commander.",

  "finalCta.title": "Prêt à explorer USFans ?",
  "finalCta.body": "Parcourez la feuille, apprenez le processus et continuez vers le site principal quand vous êtes prêt.",
  "finalCta.button": "Explorer les ressources USFans",

  "footer.resources": "Ressources",
  "footer.company": "Entreprise",
  "footer.legal": "Légal",
  "footer.language": "Langue",
  "footer.about": "À propos",
  "footer.methodology": "Méthodologie",
  "footer.editorial": "Politique éditoriale",
  "footer.contact": "Contact",
  "footer.privacy": "Confidentialité",
  "footer.terms": "Conditions",
  "footer.disclaimer": "Avertissement",
  "footer.rights": "Tous droits réservés.",
  "footer.disclaimerText": "Les informations sont destinées à la recherche et à l'éducation. La disponibilité des produits, les prix et les conditions de livraison peuvent changer. Vérifiez toujours les informations actuelles avant d'acheter.",

  "article.meta": "Guide complet 2026 sur l'USFans Spreadsheet — ce que c'est, comment ça marche et comment l'utiliser pour les trouvailles, liens W2C, QC et livraison.",
  "article.backHome": "Retour à l'accueil",
  "article.updated": "Dernière mise à jour",
  "article.readTime": "min de lecture",
  "article.toc": "Sommaire",
  "article.notFound": "Article introuvable",
  "article.related": "Envie d'explorer les catégories organisées ? Retournez à la page d'accueil d'USFansSheet pour parcourir la liste complète des catégories, ou continuez vers la boutique principale ci-dessous.",
};